/* Product video gallery (v1.25.10).
   Moves the video thumbnails rendered by snippets/oath-video-thumbs.liquid into the thumbnail rail
   and plays the selected video inside the main image frame. Independent of product-gift.js.
   Visual audit pass: video thumbnails go right after the first image (not at the end of the rail),
   so they stay in the one visible row; the stage shows the video's preview image until the player
   has loaded, instead of a black box. */
(function () {
  function init() {
    var store = document.getElementById('oath-video-thumbs');
    var rail = document.querySelector('.product-thumbnails');
    var host = document.querySelector('.product-main-image');
    if (!store || !rail || !host) return;

    var vthumbs = [].slice.call(store.querySelectorAll('.thumb-video'));
    if (!vthumbs.length) return;

    var stage = null;

    function closeStage() {
      if (stage) { stage.remove(); stage = null; }
      var img = host.querySelector('img');
      if (img) img.style.visibility = '';
      vthumbs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-pressed', 'false'); });
    }

    function openStage(thumb) {
      closeStage();
      document.querySelectorAll('.thumb-image').forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-pressed', 'false'); });
      thumb.classList.add('active');
      thumb.setAttribute('aria-pressed', 'true');

      stage = document.createElement('div');
      stage.className = 'pg-video-stage';
      var poster = thumb.dataset.poster;
      if (poster) {
        stage.style.backgroundImage = 'url("' + poster.replace(/"/g, '%22') + '")';
        stage.classList.add('has-poster');
      }
      var src = thumb.dataset.videoSrc;
      if (thumb.dataset.videoType === 'video') {
        var v = document.createElement('video');
        v.src = src;
        if (poster) v.poster = poster;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        stage.appendChild(v);
      } else {
        var f = document.createElement('iframe');
        f.src = src;
        f.title = 'Product video';
        f.allow = 'autoplay; fullscreen; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('frameborder', '0');
        f.className = 'is-loading';
        f.addEventListener('load', function () { f.className = ''; });
        setTimeout(function () { f.className = ''; }, 4000);
        stage.appendChild(f);
      }
      host.appendChild(stage);
      var img = host.querySelector('img');
      if (img) img.style.visibility = 'hidden';
    }

    var firstImage = rail.querySelector('.thumb-image');
    var ref = firstImage ? firstImage.nextSibling : null;
    vthumbs.forEach(function (t) {
      rail.insertBefore(t, ref);
      t.addEventListener('click', function () { openStage(t); });
    });
    store.remove();

    document.querySelectorAll('.thumb-image:not(.thumb-video)').forEach(function (t) {
      t.addEventListener('click', closeStage);
    });
    document.querySelectorAll('.variant-btn').forEach(function (b) {
      b.addEventListener('click', closeStage);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
